import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'anonimizzate',
  titolo: 'Schede con «Dati anonimizzati»',
  gruppo: 'Le schede delle persone',
  permesso: ['persona.crea', 'persona.modifica'],
  aCheServe: 'Per chi non può firmare l’informativa (persone irregolari, minori, persone protette) la scheda si '
    + 'registra con le sole iniziali e senza dati che la identificano. Gli interventi si registrano lo stesso.',
  parti: [
    {
      titolo: 'Creare una scheda anonimizzata',
      permesso: 'persona.crea',
      passi: [
        'In «Nuova scheda utente» scegli il profilo «Migrante o con background migratorio».',
        'Spunta «Dati anonimizzati».',
        'Scrivi nome e cognome solo con le iniziali, per esempio «M.» e «A.».',
        'Della nascita indica l’anno o la fascia d’età. Non servono codice fiscale, recapiti, indirizzi, '
          + 'luogo di nascita e documenti.',
        'Compila il resto: genere, paese, comune, lingue, sede, condizione giuridica. Poi «Salva la scheda».',
      ],
      immagine: {
        file: 'anonimizzate.webp', larghezza: 1200, altezza: 760,
        descrizione: 'Una scheda con l’etichetta Dati anonimizzati e il nome scritto con le sole iniziali.',
      },
    },
    {
      titolo: 'Che cosa cambia',
      testo: [
        'Niente consensi da firmare: interventi, mediazioni e attività si registrano lo stesso. La scheda da '
          + 'firmare non si stampa.',
        'Negli elenchi e nella scheda compare l’etichetta «Dati anonimizzati». Il controllo dei doppioni non '
          + 'la confronta con le altre.',
      ],
    },
    {
      titolo: 'Quando la persona può dare i suoi dati',
      permesso: 'persona.modifica',
      passi: [
        'Apri la scheda e premi «Modifica» nei «Dati anagrafici».',
        'Togli la spunta «Dati anonimizzati» e scrivi nome e cognome per intero.',
        'Da quel momento valgono le regole normali: servono i consensi 1 e 2 per registrare interventi.',
      ],
      nota: 'Ogni spunta messa o tolta resta nel registro eventi.',
    },
    {
      titolo: 'Importare schede anonimizzate da Excel',
      permesso: 'persona.crea',
      passi: [
        'In «Beneficiari» premi «Importa schede anonimizzate» e scarica il tracciato.',
        'Compila il foglio «Schede», una riga per persona. Obbligatorie solo iniziali e sede; poi, se li sai, '
          + 'genere, anno o fascia d’età, paesi, comune, lingue, conoscenza dell’italiano. Le tendine propongono '
          + 'i valori ammessi; il foglio «Istruzioni» spiega ogni colonna.',
        'Se indichi un progetto, indica anche la tipologia del percorso: la scheda entra nel progetto con un '
          + 'percorso aperto.',
        'Carica il foglio e guarda l’anteprima: ogni riga è «nuova» o «da correggere», con il motivo.',
        'I «possibili doppioni» (stesse iniziali, genere, anno e sede) partono esclusi: includili se sono '
          + 'persone diverse. Poi conferma.',
      ],
      nota: 'Niente nomi interi, codici o contatti nel foglio. Se una riga inclusa ha un errore, non entra nessuna '
        + 'scheda. Senza la conoscenza dell’italiano, o senza anno e fascia d’età, la scheda entra «Da completare»: '
        + 'il dato si aggiunge poi dalla scheda con «Completa la scheda».',
    },
  ],
  avvertenze: [
    {
      quando: 'La spunta «Dati anonimizzati» non c’è.',
      cosaFare: 'Vale solo per il profilo «Migrante o con background migratorio» e solo su una scheda che non '
        + 'ha ancora dati che la identificano.',
    },
  ],
  vediAnche: ['nuova-scheda', 'consensi'],
  parole: ['anonimo', 'iniziali', 'irregolare', 'minore', 'senza documenti', 'protetta'],
}

export default capitolo
